<div class="modal-content modal-notification-permission">
  <div class="modal-header">
    <h4 class="modal-title">
      <i class="material-symbols-outlined">notifications</i>
      Notificações de Obras
    </h4>
    <div class="header-right">
      <button
        type="button"
        class="btn-closer close pull-right"
        aria-label="Close"
        (click)="fecharModalX()"
      >
        X
      </button>
    </div>
  </div>

  <div class="modal-body">
    <div class="modal-content-wrapper">
      <div class="logo-container">
        <i class="material-symbols-outlined notification-bell"
          >notifications_active</i
        >
      </div>

      <h5 class="notification-question">
        Quer receber notificações sobre novas obras?
      </h5>

      <p class="notification-description">
        Toda segunda-feira você será notificado com a quantidade de novas obras
        adicionadas à plataforma.
      </p>

      <div class="notification-info">
        <p>
          As notificações aparecerão no seu navegador mesmo quando esta aba
          estiver fechada.
        </p>
        <p class="config-info">
          Você pode alterar essa configuração a qualquer momento nas
          configurações do navegador.
        </p>
      </div>

      <div
        class="browser-instruction"
        *ngIf="showBrowserInstruction"
        style="display: none"
      >
        <div class="arrow-container">
          <div class="arrow-circle">
            <i class="material-symbols-outlined">north</i>
          </div>
          <div class="arrow-line"></div>
        </div>
        <p class="instruction-text">
          <strong>Clique em "Permitir" na notificação do navegador</strong>
        </p>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn-cancelar" (click)="fecharModal()" [disabled]="isLoading">
      Agora não
    </button>
    <button
      class="btn-confirmar"
      (click)="solicitarNotificacoes()"
      [disabled]="isLoading"
    >
      Quero receber notificações
    </button>
  </div>
</div>
